import * as React from 'react';
import { ToolBarContainer } from '../../../../../../designSystem/compositeComponents/ButtonToolBar';
import { PageHeader } from '../../../../../../designSystem/PageHeader';
import { amorgLocalStorage } from '../../../../../../utils/amorgLocalStorage';
import { Tabber, TabItem } from '../../../../../../designSystem/Tabber';
import { ComparisonReportPanel } from './subReports/ComparisonReportPanel';
import { DetailsReportPanel } from './subReports/DetailsReportPanel';
import { OverviewReportPanel } from './subReports/OverviewReportPanel';
import { WorkplaceAssessmentComponentProps } from '../_components/WorkplaceAssessmentComponentProps';

export function ReportPanel(props:WorkplaceAssessmentComponentProps): JSX.Element 
{
    type ReportTab = 'overview' | 'comparison' | 'details';
    const [selectedTab, setSelectedTab] = React.useState<'overview' | 'comparison' | 'details' | undefined>(undefined);
    const [headerButtons, setHeaderButtons] = React.useState<React.ReactNode>(undefined);

    React.useEffect(() => {
        if(!props.survey)
            return;

        const key = amorgLocalStorage.surveyReport.viewMode.getKey();
        let viewMode = amorgLocalStorage.surveyReport.viewMode.readOrCreate(key) as ReportTab;
        if(viewMode === 'comparison' && props.survey.segmentations.length === 0)
        {
            amorgLocalStorage.surveyReport.viewMode.write(key, 'overview');
            viewMode = 'overview';
        }
        setSelectedTab(viewMode);
    },[]);

    const tabItems:TabItem[] = [
        { tabName:'overview', text:'Overblik', leadingContent:'navigation_map' },
        { tabName:'details', text:'Detaljevisning', leadingContent:'table' }
    ]

    if((props.survey?.segmentations || []).length > 0)
    {
        tabItems.splice(1,0,{ tabName:'comparison', text:'Sammenligning', leadingContent:'interface_user_users' });
    }

    return (
        <>
            <PageHeader
                headerText='Rapport'
                headerStyle='secondary-gray'
                buttons={
                    <ToolBarContainer>
                        {headerButtons}
                    </ToolBarContainer>
                } />

            <Tabber variant='text' inline alignment='center'
                selectedTabName={selectedTab}
                items={tabItems}
                onClick={tabName => {
                    setSelectedTab(tabName as 'overview' | 'comparison' | 'details')
                    const key = amorgLocalStorage.surveyReport.viewMode.getKey();
                    amorgLocalStorage.surveyReport.viewMode.write(key, tabName as 'overview' | 'comparison' | 'details');
                }}
            />

            {selectedTab === 'overview' &&
                <OverviewReportPanel {...props} setHeaderButtons={setHeaderButtons} />
            }

            {selectedTab === 'comparison' &&
                <ComparisonReportPanel {...props} setHeaderButtons={setHeaderButtons} />
            }

            {selectedTab === 'details' &&
                <DetailsReportPanel {...props} setHeaderButtons={setHeaderButtons} />
            }
        </>
    );
}